// Tratamiento preferido del usuario (cómo quiere que nos dirijamos a él).
// Social + profesional. Se guarda en users.honorific como la CLAVE (ej. 'ing').

export const HONORIFICS = ['sr', 'sra', 'srta', 'lic', 'ing', 'dr', 'dra', 'arq', 'prof', 'none'];

// Abreviatura canónica: se antepone al nombre en saludos (asistente, etc.).
export const HONORIFIC_ABBR = {
  sr: 'Sr.',
  sra: 'Sra.',
  srta: 'Srta.',
  lic: 'Lic.',
  ing: 'Ing.',
  dr: 'Dr.',
  dra: 'Dra.',
  arq: 'Arq.',
  prof: 'Prof.',
  none: '',
};

// Palabra completa hablada (para la voz / TTS): 'ing' -> 'ingeniero'.
export const HONORIFIC_SPOKEN = {
  sr: 'señor',
  sra: 'señora',
  srta: 'señorita',
  lic: 'licenciado',
  ing: 'ingeniero',
  dr: 'doctor',
  dra: 'doctora',
  arq: 'arquitecto',
  prof: 'profesor',
  none: '',
};

// Prefijo listo para anteponer al nombre. '' si no hay tratamiento.
export function honorificPrefix(key) {
  return HONORIFIC_ABBR[key] || '';
}

// Forma hablada completa. '' si no hay tratamiento.
export function honorificSpoken(key) {
  return HONORIFIC_SPOKEN[key] || '';
}

// Etiqueta para la UI: abreviatura para los títulos; palabra i18n para 'none'.
export function honorificLabel(key, t) {
  if (key === 'none') return t('honorifics.none');
  return HONORIFIC_ABBR[key] || '';
}
